/* Dedica personalizzata — logica del builder (sections/tc-ded.liquid).
   Stessa logica della vecchia pagina incollata nel corpo Shopify:
   - 2 colori di biglietto, 5 disegni per colore (immagini sul CDN Shopify)
   - il messaggio (max 500 caratteri), colore e disegno vanno al carrello come proprietà
     Messaggio / Colore / Disegno insieme alla prima variante del prodotto "dedica-personalizzata"
   - POST /cart/add (form nativo) */
(function () {
  "use strict";

  var wrapper = document.getElementById("dedica-builder");
  if (!wrapper) return;

  var productHandle = "dedica-personalizzata";

  var isEn = wrapper.dataset.lang === "en";
  var t = {};
  try {
    t = JSON.parse(wrapper.querySelector("[data-tc-ded-i18n]").textContent);
  } catch (e) {}
  /* Testo mostrato al cliente nella sua lingua. Colore e disegno inviati al carrello restano
     SEMPRE in italiano (title): chi prepara gli ordini li legge uguali in ogni lingua. */
  function tr(item, key) {
    return isEn && item[key + "En"] ? item[key + "En"] : item[key];
  }

  var form = document.getElementById("dedica-builder-form");
  var steps = wrapper.querySelectorAll(".db-step");
  var nextButtons = wrapper.querySelectorAll(".db-next");
  var prevButtons = wrapper.querySelectorAll(".db-prev");

  var colorOptionsContainer = document.getElementById("db-color-options");
  var designGrid = document.getElementById("db-design-grid");
  var messageInput = document.getElementById("db-message-input");
  var charCount = document.getElementById("db-char-count");

  var hiddenVariantId = document.getElementById("db-variant-id");
  var colorHidden = document.getElementById("db-color-hidden");
  var designHidden = document.getElementById("db-design-hidden");
  var messageHidden = document.getElementById("db-message-hidden");

  var summaryColor = document.getElementById("db-summary-color");
  var summaryDesign = document.getElementById("db-summary-design");
  var summaryMessage = document.getElementById("db-summary-message");
  var summaryPreviewImage = document.getElementById("db-summary-preview-image");

  var progress = document.getElementById("db-progress");
  var progressSteps = wrapper.querySelectorAll(".db-progress-step");
  var progressFill = wrapper.querySelector(".db-progress-fill");

  var selectedColor = null;
  var selectedDesign = null;

  var colorData = [
    {
      id: "beige",
      title: "Beige",
      titleEn: "Beige",
      desc: "Elegante biglietto crema",
      descEn: "Elegant cream card",
      image: "https://cdn.shopify.com/s/files/1/0857/9268/6416/files/Biglietto_B.jpg?v=1777470191"
    },
    {
      id: "rosa",
      title: "Rosa",
      titleEn: "Pink",
      desc: "Delicato biglietto rosa",
      descEn: "Delicate pink card",
      image: "https://cdn.shopify.com/s/files/1/0857/9268/6416/files/Biglietto_R.jpg?v=1777470201"
    }
  ];

  var designData = {
    beige: [
      { id: "mamma", title: "Festa della Mamma", titleEn: "Mother's Day", image: "https://cdn.shopify.com/s/files/1/0857/9268/6416/files/Crema_-_mamma.png?v=1777469674" },
      { id: "compleanno1", title: "Compleanno 1", titleEn: "Birthday 1", image: "https://cdn.shopify.com/s/files/1/0857/9268/6416/files/Crema_-_compleanno_1.png?v=1777469705" },
      { id: "compleanno2", title: "Compleanno 2", titleEn: "Birthday 2", image: "https://cdn.shopify.com/s/files/1/0857/9268/6416/files/Crema_-_compleanno_2.png?v=1777469802" },
      { id: "cornice1", title: "Cornice 1", titleEn: "Frame 1", image: "https://cdn.shopify.com/s/files/1/0857/9268/6416/files/Crema_-_scrivi.png?v=1777469776" },
      { id: "cornice2", title: "Cornice 2", titleEn: "Frame 2", image: "https://cdn.shopify.com/s/files/1/0857/9268/6416/files/Crema_-_cornice.png?v=1777469901" }
    ],
    rosa: [
      { id: "mamma", title: "Festa della Mamma", titleEn: "Mother's Day", image: "https://cdn.shopify.com/s/files/1/0857/9268/6416/files/Rosa_-_mamma.png?v=1777469632" },
      { id: "compleanno1", title: "Compleanno 1", titleEn: "Birthday 1", image: "https://cdn.shopify.com/s/files/1/0857/9268/6416/files/Rosa_-_compleanno_1.png?v=1777469750" },
      { id: "compleanno2", title: "Compleanno 2", titleEn: "Birthday 2", image: "https://cdn.shopify.com/s/files/1/0857/9268/6416/files/Rosa_-_compleanno_2.png?v=1777469721" },
      { id: "cornice1", title: "Cornice 1", titleEn: "Frame 1", image: "https://cdn.shopify.com/s/files/1/0857/9268/6416/files/Rosa_-_scrivi.png?v=1777469649" },
      { id: "cornice2", title: "Cornice 2", titleEn: "Frame 2", image: "https://cdn.shopify.com/s/files/1/0857/9268/6416/files/Rosa_-_cornice.png?v=1777469859" }
    ]
  };

  function updateProgress(stepIndex) {
    if (!progress) return;

    if (stepIndex === 0) {
      progress.classList.add("db-progress-hidden");
      progressSteps.forEach(function (ps) {
        ps.classList.remove("db-progress-active", "db-progress-completed");
      });
      if (progressFill) progressFill.style.width = "0%";
      return;
    }

    progress.classList.remove("db-progress-hidden");

    var percentage = ((stepIndex - 1) / (progressSteps.length - 1)) * 100;
    if (progressFill) progressFill.style.width = percentage + "%";

    progressSteps.forEach(function (ps) {
      var s = parseInt(ps.getAttribute("data-step"), 10);
      ps.classList.remove("db-progress-active", "db-progress-completed");
      if (s < stepIndex) ps.classList.add("db-progress-completed");
      else if (s === stepIndex) ps.classList.add("db-progress-active");
    });
  }

  function showStep(index) {
    steps.forEach(function (step, i) {
      step.classList.toggle("db-step-active", i === index);
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
    updateProgress(index);
    updateSummary();
  }

  /* le schede (label) si scelgono anche da tastiera con Invio/Spazio */
  function makeKeyboardSelectable(label, action) {
    label.tabIndex = 0;
    label.addEventListener("keydown", function (e) {
      if ((e.key === "Enter" || e.key === " ") && e.target === label) {
        e.preventDefault();
        action();
      }
    });
  }

  function renderColorOptions() {
    colorOptionsContainer.innerHTML = "";

    colorData.forEach(function (color) {
      var label = document.createElement("label");
      label.className = "db-color-option";
      label.setAttribute("data-color-id", color.id);

      var imgWrapper = document.createElement("div");
      imgWrapper.className = "db-color-image-wrapper";

      var img = document.createElement("img");
      img.src = color.image;
      img.alt = tr(color, "title");
      img.loading = "lazy";
      img.decoding = "async";
      imgWrapper.appendChild(img);

      var info = document.createElement("div");
      info.className = "db-color-info";

      var title = document.createElement("div");
      title.className = "db-color-title";
      title.textContent = tr(color, "title");

      var desc = document.createElement("div");
      desc.className = "db-color-desc";
      desc.textContent = tr(color, "desc");

      info.appendChild(title);
      info.appendChild(desc);

      label.appendChild(imgWrapper);
      label.appendChild(info);

      label.addEventListener("click", function (e) {
        e.preventDefault();
        selectColor(color.id);
      });
      makeKeyboardSelectable(label, function () { selectColor(color.id); });

      colorOptionsContainer.appendChild(label);
    });
  }

  function selectColor(colorId) {
    selectedColor = colorId;
    selectedDesign = null;

    colorOptionsContainer.querySelectorAll(".db-color-option").forEach(function (opt) {
      opt.classList.toggle("db-color-selected", opt.getAttribute("data-color-id") === colorId);
    });

    renderDesignOptions(colorId);
  }

  function renderDesignOptions(colorId) {
    designGrid.innerHTML = "";

    var designs = designData[colorId] || [];

    designs.forEach(function (design) {
      var label = document.createElement("label");
      label.className = "db-design-card";
      label.setAttribute("data-design-id", design.id);

      var imgWrapper = document.createElement("div");
      imgWrapper.className = "db-design-image-wrapper";

      var img = document.createElement("img");
      img.src = design.image;
      img.alt = tr(design, "title");
      img.loading = "lazy";
      img.decoding = "async";
      imgWrapper.appendChild(img);

      // Zoom button
      var zoomBtn = document.createElement("button");
      zoomBtn.type = "button";
      zoomBtn.className = "db-design-zoom-btn";
      zoomBtn.innerHTML =
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';
      zoomBtn.setAttribute("aria-label", t.zoomAria || "Ingrandisci immagine");
      zoomBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        openZoomModal(design.image, tr(design, "title"));
      });
      imgWrapper.appendChild(zoomBtn);

      var info = document.createElement("div");
      info.className = "db-design-info";

      var title = document.createElement("div");
      title.className = "db-design-title";
      title.textContent = tr(design, "title");

      info.appendChild(title);

      label.appendChild(imgWrapper);
      label.appendChild(info);

      label.addEventListener("click", function (e) {
        e.preventDefault();
        selectDesign(design);
      });
      makeKeyboardSelectable(label, function () { selectDesign(design); });

      designGrid.appendChild(label);
    });
  }

  // Zoom Modal Functions (la scheda resta dentro la sezione: il CSS isolato la raggiunge)
  var modal = document.getElementById("db-zoom-modal");
  var modalImg = document.getElementById("db-zoom-modal-image");
  var modalTitle = document.getElementById("db-zoom-modal-title");

  function openZoomModal(imageSrc, imageTitle) {
    if (modal && modalImg && modalTitle) {
      modalImg.src = imageSrc;
      modalImg.alt = imageTitle;
      modalTitle.textContent = imageTitle;
      modal.classList.add("db-zoom-open");
      document.body.style.overflow = "hidden";
    }
  }

  function closeZoomModal() {
    if (modal) {
      modal.classList.remove("db-zoom-open");
      document.body.style.overflow = "";
    }
  }

  // Close zoom modal on click outside image or on close button
  modal.addEventListener("click", function (e) {
    if (!e.target.closest(".db-zoom-image") || e.target.closest(".db-zoom-close")) {
      closeZoomModal();
    }
  });

  // Close zoom modal on Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeZoomModal();
  });

  function selectDesign(design) {
    selectedDesign = design;

    designGrid.querySelectorAll(".db-design-card").forEach(function (card) {
      card.classList.toggle("db-design-selected", card.getAttribute("data-design-id") === design.id);
    });
  }

  function updateSummary() {
    var colorTitle = "–";
    var colorShown = "–";
    if (selectedColor) {
      var colorInfo = colorData.find(function (c) { return c.id === selectedColor; });
      if (colorInfo) {
        colorTitle = colorInfo.title;
        colorShown = tr(colorInfo, "title");
      }
    }
    summaryColor.textContent = colorShown;
    colorHidden.value = colorTitle;

    var designTitle = "–";
    var designShown = "–";
    var designImage = "";
    if (selectedDesign) {
      designTitle = selectedDesign.title;
      designShown = tr(selectedDesign, "title");
      designImage = selectedDesign.image;
    }
    summaryDesign.textContent = designShown;
    designHidden.value = designTitle;

    if (designImage) {
      summaryPreviewImage.src = designImage;
      summaryPreviewImage.style.display = "block";
    } else {
      summaryPreviewImage.style.display = "none";
    }

    var message = messageInput.value.trim() || "–";
    summaryMessage.textContent = message;
    messageHidden.value = message;
  }

  if (messageInput) {
    messageInput.addEventListener("input", function () {
      charCount.textContent = messageInput.value.length;
      updateSummary();
    });
  }

  nextButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var currentStep = btn.closest(".db-step");
      var currentIndex = Array.prototype.indexOf.call(steps, currentStep);

      // Validazioni
      if (currentIndex === 1 && !selectedColor) {
        alert(t.alertColor);
        return;
      }

      if (currentIndex === 2 && !selectedDesign) {
        alert(t.alertDesign);
        return;
      }

      var nextIndex = currentIndex + 1;
      if (nextIndex < steps.length) showStep(nextIndex);
    });
  });

  prevButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var currentStep = btn.closest(".db-step");
      var currentIndex = Array.prototype.indexOf.call(steps, currentStep);
      var prevIndex = currentIndex - 1;
      if (prevIndex >= 0) showStep(prevIndex);
    });
  });

  form.addEventListener("submit", function () {
    updateSummary();
  });

  function loadProduct() {
    return fetch("/products/" + encodeURIComponent(productHandle) + ".js", { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Impossibile caricare il prodotto");
        return response.json();
      })
      .then(function (product) {
        if (product.variants && product.variants.length > 0) {
          hiddenVariantId.value = product.variants[0].id;
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  showStep(0);
  renderColorOptions();
  loadProduct();
})();
